import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent {

  constructor() { }

}
